module.exports = __webpack_public_path__ + "static/checkset5-6c17d25dac2a8070991d98d8780b9c8e.jpeg";